import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';
import { FETCH_FEE_GRID_NAME } from './feeGridBreadcrumb.query';

export const FeeGridBreadcrumb = () => {
  const { id } = useParams();
  const { data } = useQuery(FETCH_FEE_GRID_NAME, {
    variables: { feeTierId: id ?? '' },
    skip: !id,
  });

  return data?.fetchFeeTier?.feeTier?.name ?? '';
};
